export const LOCATION_CHANGED = "LOCATION_CHANGED";

export const onLocationChanged = pathname => ({
    type: LOCATION_CHANGED,
    pathname,
})
